import {types} from './types';

const setGetSupportListAction = (payload) => {
    return {
        type: types.SET_SUPPORT_LIST,
        payload,
      }
}

const setGetSupportViewAction = (payload) => {
  return {
    type: types.SET_SUPPORT_VIEW,
    payload
  }
}

export {
  setGetSupportListAction,
  setGetSupportViewAction
}
